// UI components
import { CosmosButton, CosmosText, CosmosIconDelete, CosmosIconCheckmark, CosmosIconCloseSmall } from "@cosmos/web/react"
import { useNavigate } from "react-router-dom"
import VCarbLogo from "../../../assets/images/vcarb-logo-2.png"

// Returns the markup for a group row in any given list
export default function GroupRow({ id, name, mainContactFirstName, mainContactLastName, mainContactEmail, maximumGuests, secondaryContactFirstName, secondaryContactLastName, secondaryContactEmail }) {
	// Setup a navigation instance from react-router
	const navigate = useNavigate()

	return (
		<div className="thosp-guestgroup-row">
			<div className="row-logo">
				<img
					src={VCarbLogo}
					alt="Visa Cash App Racing Bulls"
				/>
			</div>

			<CosmosText
				appearance="dark"
				weight="bold"
				spacing="none">
				{name}
			</CosmosText>

			<CosmosText
				appearance="dark"
				size="small"
				spacing="none">
				{mainContactFirstName} {mainContactLastName}, {mainContactEmail}
			</CosmosText>

			{secondaryContactEmail !== null && secondaryContactEmail !== "" && secondaryContactEmail !== undefined ? (
				<CosmosText
					appearance="dark"
					size="small"
					spacing="none">
					{secondaryContactFirstName} {secondaryContactLastName}, {secondaryContactEmail}
				</CosmosText>
			) : (
				""
			)}

			<div className="thosp-event-location">
				<CosmosText
					appearance="dark"
					size="x-small"
					spacing="none"
					kind="subtle">
					Max {maximumGuests} Guests
				</CosmosText>
			</div>

			<div className="thosp-tab-navigation">
				<CosmosButton
					kind="secondary"
					size="small"
					appearance="dark"
					shape="rectangle"
					onClick={() => navigate(`/group/${id}/edit`)}>
					Edit
				</CosmosButton>

				<CosmosButton
					kind="primary"
					size="small"
					shape="square"
					onClick={() => navigate(`/group/${id}/delete`)}>
					<CosmosIconDelete />
				</CosmosButton>
			</div>
		</div>
	)
}
